export default __webpack_public_path__ + "static/media/pc.3276739f.svg";